import React from 'react'
import { translate } from 'react-i18next'
import PropTypes from 'prop-types'
import LogoWithoutDesc from 'images/logo-without-desc.svg'
import WarningIcon from 'images/new-warning-icon.svg'

/**
 * Full page shown to unauthenticated users while the system is under maintenance.
 * Blocks any login: rendered instead of the routes (see App.js).
 * The message comes from the public endpoint maintenance-block/consult/portal.
 */
const MaintenancePage = (props) => {
  const { translate, message } = props

  return (
    <div className='container-fluid maintenance-hero'>
      <div className='maintenance-card'>
        <img className='maintenance-logo' src={LogoWithoutDesc} alt='Leroy Merlin' />

        <img className='maintenance-alert' src={WarningIcon} alt='' />

        <h3>{translate('maintenance.title')}</h3>

        <p>{message}</p>
      </div>
    </div>
  )
}

MaintenancePage.propTypes = {
  translate: PropTypes.func.isRequired,
  message: PropTypes.string,
}

const ComponentTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(MaintenancePage)

export default ComponentTranslated

export { MaintenancePage }
